import React, { type ReactNode } from 'react';

import './StepperContent.css';

interface StepperContentProps {
  stepContent: ReactNode;
}

function StepperContent({ stepContent }: StepperContentProps) {
  return (
    <div className='Ext-StepperContent-content'>
      {/* {activeStep} */}
      {stepContent}
    </div>
  );
}

export default StepperContent;

StepperContent.defaultProps = {
  // activeStep: 0,
};
